/**
 * Filtro de Artesãos em Tempo Real
 * Versão compatível com jQuery 3.7.1 (WordPress Mode)
 */
jQuery(document).ready(function($) {
    // Cache de seletores para melhor performance
    const $inputFiltro = $('#input-filtro');
    const $itens       = $('.item-artesao');
    const $avisoVazio  = $('#aviso-vazio');
    const $paginacao   = $('.paginacao-numerada');

    // Escuta o evento de digitação
    $inputFiltro.on('input', function() {
        // Captura o valor, limpa acentos e espaços extras
        const termo = $(this).val()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim();

        let encontrados = 0;

        // Se o campo estiver vazio, resetamos a visualização
        if (termo.length === 0) {
            $itens.show();
            $paginacao.show();
            $avisoVazio.hide();
            return;
        }

        // Filtra os itens
        $itens.each(function() {
            const $item = $(this);
            const nomeArtesao = $item.attr('data-nome')
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");

            if (nomeArtesao.indexOf(termo) > -1) {
                $item.show();
                encontrados++;
            } else {
                $item.hide();
            }
        });

        // Feedback de interface
        $paginacao.hide(); // Esconde paginação durante a busca
        
        if (encontrados === 0) {
            $avisoVazio.fadeIn(200);
        } else {
            $avisoVazio.hide();
        }
    });
});